export const helper = {
    removeFirstElement,
    getQueryParametersFromUrl,
    getJwtFromUrl,
    decodeJwt,
    ticksToDate,
    ticksToDateString,
    ticksToTimeString,
    groupBy,
    isSameConcept,
    isAnyConceptIn,
    logJobStatus,
    ConditionOperator,
    mergeHighlightsWithFeedback
};

function removeFirstElement(array, element) {
    const index = array.indexOf(element);
    if (index > -1) { array.splice(index, 1) }
    return array;
}

function getQueryParametersFromUrl(url) {
    /*const params = new Proxy(new URLSearchParams(url), {
        get: (searchParams, prop) => searchParams.get(prop),
    });*/
    const params = new URLSearchParams(url);
    return params;
}

function decodeJwt(value) {
    if (!value) return "";
    let dataParts = value.split('.')
    if (dataParts.length !== 3)
        throw new Error("invalid jwt from oneflow");
    let dataType = dataParts[0]
    let encodedData = dataParts[1]
    let sourceDigest = dataParts[2]
    if (!dataType || !encodedData || !sourceDigest) throw new Error('invalid value(s)');
    const json = Buffer.from(encodedData, 'base64').toString('utf8');
    const decodedData = JSON.parse(json);
    return decodedData;
}

function getJwtFromUrl() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    let jwtBase64AndSigning = params.jwt;
    let decodedData = decodeJwt(jwtBase64AndSigning)

    // { account_id: 435453, email: "christian.wigren@legly.io", id: 456283, exp: 1712738213 }
    return decodedData;
}

function ticksToDate(ticks) {
    const ticksPerMillisecond = 10000;
    const epochTicks = 621355968000000000;
    const javascriptTimestamp = (ticks - epochTicks) / ticksPerMillisecond;
    const date = new Date(javascriptTimestamp);
    return date;
}

function ticksToDateString(ticks, includeTime = false) {
    let date = this.ticksToDate(ticks);
    if (includeTime)
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    else
        return date.toLocaleDateString();
}

function ticksToTimeString(ticks) {
    let date = this.ticksToDate(ticks);
    return date.toLocaleTimeString();
}

function groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

function isSameConcept(code1, code2, ignoreLanguage = true) {
    if (ignoreLanguage) {
        return code1.replace('_SV', '') === code2.replace('_SV', '');
    }
    return code1 === code2;
};

function isAnyConceptIn(code, codesToMatch, ignoreLanguage = true) {
    return codesToMatch.includes(code) || (ignoreLanguage && codesToMatch.includes(code.replace('_SV', '')));
};

// Function to safely log the success status of all tasks
function logTaskSuccessStatus(tasks) {
    if (!Array.isArray(tasks)) {
        console.error("The tasks property is not an array.");
        return;
    }

    let runningTaskCount = 0;
    let wasSuccessfulCount = 0;
    let wasNotSuccessfulCount = 0;
    const durationByTaskName = {};

    tasks.forEach((task, index) => {
        try {
            if (typeof task !== 'object' || task === null) {
                throw new Error(`Invalid task object at index ${index}`);
            }
            if (!('wasSuccessful' in task)) {
                throw new Error(`Missing wasSuccessful property in task at index ${index}`);
            }
            if (typeof task.wasSuccessful !== 'boolean') {
                throw new Error(`Invalid wasSuccessful value in task at index ${index}`);
            }
            if (!('isRunning' in task)) {
                throw new Error(`Missing isRunning property in task at index ${index}`);
            }
            if (typeof task.wasSuccessful !== 'boolean') {
                throw new Error(`Invalid isRunning value in task at index ${index}`);
            }
            if (!('exceptionMessage' in task)) {
                throw new Error(`Missing exceptionMessage property in task at index ${index}`);
            }
            if (typeof task.exceptionMessage !== 'string') {
                throw new Error(`Invalid exceptionMessage value in task at index ${index}`);
            }

            if (task.isRunning === false && task.wasSuccessful === false) {
                console.log(`Task ${index + 1}: ${task.name}, Was Successful: ${task.wasSuccessful}: ${task.exceptionMessage}`);
            }

            if (task.isRunning === true) {
                runningTaskCount++;
            }
            if (task.isRunning === false && task.wasSuccessful === true) {
                wasSuccessfulCount++;
            }
            if (task.isRunning === false && task.wasSuccessful === false) {
                wasNotSuccessfulCount++;
            }

            // Calculate duration in milliseconds
            // const duration = (task.timeFinished - task.wasCreated) / 10000; // Convert ticks to milliseconds
            const duration = (task.timeFinished - task.wasCreated) / 10000000; // Convert ticks to seconds

            if (duration > 0) {
                // Group durations by task name
                if (!durationByTaskName[task.name]) {
                    durationByTaskName[task.name] = [];
                }
                durationByTaskName[task.name].push(duration);
            }

        } catch (error) {
            console.error(error.message);
        }
    });

    // Log the number of tasks that are currently running
    console.log(`Number of tasks that is running: ${runningTaskCount}/${tasks.length} - Success: ${wasSuccessfulCount}/${tasks.length} - Failed: ${wasNotSuccessfulCount}/${tasks.length}`);

    // Calculate and log mean duration for each task name in seconds
    for (const taskName in durationByTaskName) {
        const durations = durationByTaskName[taskName];
        const meanDuration = durations.reduce((sum, dur) => sum + dur, 0) / durations.length;
        console.log(`Mean duration for tasks named "${taskName}": ${meanDuration.toFixed(2)} seconds`);
    }
}

// Call the function to log the success status of all tasks
function logJobStatus(job) {
    if (typeof job !== 'object' || job === null) {
        throw new Error(`Invalid job object`);
    }
    if (!('tasks' in job)) {
        throw new Error(`Missing tasks property in job`);
    }
    if (!Array.isArray(job.tasks)) {
        console.error("The tasks property is not an array.");
    }

    logTaskSuccessStatus(job.tasks);
}

const ConditionOperator = {
    EQUALS: "EQUALS",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN: "LESS_THAN",
    GREATER_THAN_OR_EQUAL: "GREATER_THAN_OR_EQUAL",
    LESS_THAN_OR_EQUAL: "LESS_THAN_OR_EQUAL",
    CONTAINS: "CONTAINS",
    NOT_CONTAINS: "NOT_CONTAINS",
    NOT_EQUALS: "NOT_EQUALS",
    IN: "IN",
    NOT_IN: "NOT_IN",
    WAS_FOUND: "WAS_FOUND",
    WAS_NOT_FOUND: "WAS_NOT_FOUND"
};

function mergeHighlightsWithFeedback(highlights, summaryHighlights) {
    var result = [];

    if (!highlights || !highlights.map) {
        return highlights;
    }

    for (var i = 0; i < highlights.length; i++) {
        var h = highlights[i];
        var summaryHighlight = (summaryHighlights && summaryHighlights[i]) ? summaryHighlights[i] : undefined;

        var updatedHighlight = {};

        for (var key in h) {
            if (h.hasOwnProperty(key)) {
                updatedHighlight[key] = h[key];
            }
        }

        updatedHighlight.feedbackAIGuidance = summaryHighlight ? summaryHighlight.guidance : h.feedbackAIGuidance;

        result.push(updatedHighlight);
    }

    return result;
}


// WEBPACK FOOTER //
// ./src/helpers/helper.js